<template>
  <div class='ant-upload-picture-card-wrapper'>
    <div class='ant-upload-list ant-upload-list-picture-card' v-if='!image&&imageList[0]'>
      <div class='ant-upload-list-picture-card-container' v-for="(v,k) in imageList" :key='k' @click="clickImg(k)">
        <span>
          <div class="ant-upload-list-item ant-upload-list-item-done ant-upload-list-item-list-type-picture-card">
            <div class="ant-upload-list-item-info">
              <img :src="v.indexOf('http')!=-1?v:info.picdomain+'/'+v" class='ant-upload-list-item-image' />
            </div>
            <span class="ant-upload-list-item-actions" @click="delChooseImg(k)">
              <span title="删除文件" tabindex="-1" role="img" aria-label="delete" class="anticon anticon-delete"><svg class="" data-icon="delete" width="1em" height="1em" fill="currentColor" aria-hidden="true" viewBox="64 64 896 896" focusable="false">
                  <path d="M360 184h-8c4.4 0 8-3.6 8-8v8h304v-8c0 4.4 3.6 8 8 8h-8v72h72v-80c0-35.3-28.7-64-64-64H352c-35.3 0-64 28.7-64 64v80h72v-72zm504 72H160c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h60.4l24.7 523c1.6 34.1 29.8 61 63.9 61h454c34.2 0 62.3-26.8 63.9-61l24.7-523H888c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM731.3 840H292.7l-24.2-512h487l-24.2 512z">
                  </path>
                </svg></span>
            </span>
          </div>
        </span>
      </div>
    </div>
    <div class='ant-upload-list ant-upload-list-picture-card' v-else-if="image||defaultImg">
      <div class='ant-upload-list-picture-card-container' @click="clickImg(0)">
        <span>
          <div class="ant-upload-list-item ant-upload-list-item-done ant-upload-list-item-list-type-picture-card">
            <div class="ant-upload-list-item-info">
              <span>
                <img :src="image.indexOf('http')!=-1?image:info.picdomain+'/'+image" class='ant-upload-list-item-image' v-if="image || !defaultImg" />
                 <img :src="defaultImg" alt="" class='ant-upload-list-item-image ' />
              </span>
            </div>
            <span class="ant-upload-list-item-actions" @click="delChooseImg(0)" v-if="image || !defaultImg">
              <span title="删除文件" tabindex="-1" role="img" aria-label="delete" class="anticon anticon-delete"><svg class="" data-icon="delete" width="1em" height="1em" fill="currentColor" aria-hidden="true" viewBox="64 64 896 896" focusable="false">
                  <path d="M360 184h-8c4.4 0 8-3.6 8-8v8h304v-8c0 4.4 3.6 8 8 8h-8v72h72v-80c0-35.3-28.7-64-64-64H352c-35.3 0-64 28.7-64 64v80h72v-72zm504 72H160c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h60.4l24.7 523c1.6 34.1 29.8 61 63.9 61h454c34.2 0 62.3-26.8 63.9-61l24.7-523H888c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM731.3 840H292.7l-24.2-512h487l-24.2 512z">
                  </path>
                </svg></span>
            </span>
          </div>
        </span>
      </div>
    </div>
    <div class='ant-upload ant-upload-select ant-upload-select-picture-card' :style="'width:'+size.width+'px;height:'+size.height+'px'" v-if="imageList.length <  max &&!image" @click='onSearch();choose=true;'>
      <span class='ant-upload'>
        <div>
          <plus-outlined />
          <div class="ant-upload-text">选择</div>
        </div>
      </span>
    </div>
  </div>
  <!-- 选择 -->
  <a-modal :keyboard="false" v-model:visible="choose" centered style="width:700px" :width='1300' @ok="handleChoose" @cancel='checkAll=false;search.name=""' destroyOnClose>
    <!-- 头部 -->
    <div class=" s_flex_bian_c  m-t-50">
      <div class='s_flex_ali'>
        <span class=' mr15 ' v-if='group_type==1'>
          <a-button type="primary" shape="round" class='m-r-20' @click='uploadVisible=true'>
            <PlusOutlined />
            添加图片
          </a-button>
          大小不超过500K,支持gif/png/jpeg/jpg
        </span>
        <span class=' mr15 ' v-else>
          <a-button type="primary" shape="round" class='m-r-20' @click='uploadVideoVisible=true'>
            <PlusOutlined />
            添加视频
          </a-button>
          大小不超过2M
        </span>
      </div>
      <a-input-search placeholder="标题" enter-button v-model:value="search.name" @search="onSearch" style="width:300px" />
    </div>
    <!-- 素材内容 -->
    <a-layout id="components-layout-demo-custom-trigger" class="s_bf">
      <a-layout-sider :trigger="null" collapsible style="background: #fff;padding-top:20px;">
        <a-menu mode="inline" v-model:selectedKeys="defaultSelected" @click="handleMaterialCate" style="height: 546px;overflow-y: scroll;">
          <a-menu-item key="">
            <span>全部{{group_type==1?"图片":"视频"}}</span>
          </a-menu-item>
          <a-menu-item key="0">
            <span>未分组</span>
          </a-menu-item>
          <a-menu-item v-for="v in CateList" :key='v.id'>
            <span>{{v.group_name}}({{v.total}})</span><span class='fr'>
              <DeleteOutlined @click.stop="DelCate(v.id)" />
              <EditOutlined @click.stop="group=v;visible=true;groupAddType ='edit'" />
            </span>
          </a-menu-item>
        </a-menu>
        <a-button class='m-t-10' type="primary" ghost block @click.stop='visible=true;groupAddType ="add"'>
          <PlusOutlined />
          添加分组
        </a-button>
      </a-layout-sider>
      <a-layout>
        <a-layout-header style="background: #fff; padding: 0">
          <a-checkbox v-model:checked="checkAll" @change="onCheckAllChange" class='m-l-25'>
            全选
          </a-checkbox>
          <a-button type="link" class='m-r-20' @click='changGroup(checkedList)'>
            移动分组
          </a-button>
          <a-button type="link" class='m-r-20' @click="productMaterialDel">
            删除
          </a-button>
        </a-layout-header>
        <a-layout-content :style="{ margin: '0', padding: '5px', background: '#fff', minHeight: '280px' }">
          <a-checkbox-group v-model:value="checkedList" @change="onChange" class='width100'>
            <a-spin :spinning="loading">
              <ul class="s_flex_ali librayList" v-if="images.length">
                <li style="width:25%" v-for="(v,k) in images" :key='k'>
                  <div class="content ">
                    <div class="imgContent">
                      <img :src="info.picdomain+'/'+v.file_name" v-if="group_type==1" />
                      <img :src="info.picdomain+'/'+v.video_image_name" v-else />
                    </div>
                    <div class="preview" v-if="group_type!=1">
                        <video :src="info.picdomain+'/'+v.file_name" muted autoplay="autoplay"  x5-video-orientation="landscape" object-fit="cover"></video>
                    </div>
                    <!-- <div class="img_content" :style="{backgroundImage: 'url(' + v.host+'/'+(v.video_image_name?v.video_image_name:v.file_name) + ')', backgroundSize:'contain'}"></div>-->
                    <a-checkbox :value="v.id" name="type" class=' m-t-8 m-b-10 width95 s_omit'>
                      {{v.name}}.{{v.extension}}
                    </a-checkbox>
                  </div>
                  <div class="material_foot">
                    <div class="button-group">
                      <div @click='changName(v)'>改名</div>
                      <div @click='delMaterial(v.id)'>删除</div>
                    </div>
                  </div>
                </li>
              </ul>
              <a-empty v-if="!images.length" />
            </a-spin>
          </a-checkbox-group>
        </a-layout-content>
      </a-layout>
    </a-layout>
    <div class='m-l-150 p-l-50 p-t-10' style="color:#f04635">最大可选数量: {{checkedList.length+imageList.length}}/{{max}}
    </div>
    <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" />
  </a-modal>
  <!-- 添加分组 -->
  <a-modal :keyboard="false" title="分组管理" centered v-model:visible="visible" :confirm-loading="confirmLoading" @ok="handleOk" style="width:700px">
    <a-form ref="groupForm" :model="group" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-item ref="group_name" label="分组名称" name="group_name" :rules="[{ required: true, message: '请输入分组名称' },{ max: 10, message: '分组名称不超过10个字符' }]">
        <a-input v-model:value="group.group_name" />
      </a-form-item>
      <a-form-item ref="id" name="id" hidden>
        <a-input v-model:value="group.id" />
      </a-form-item>
    </a-form>
  </a-modal>
  <!-- 上传图片 -->
  <a-modal :keyboard="false" title="图片上传" centered v-model:visible="uploadVisible" :confirm-loading="confirmLoading" @ok="handleUpLoad">
    <a-form ref="upLoadForm" :model="upLoad" :label-col="{span:5}" :wrapper-col="{span:18}">
      <a-form-item ref="group_id" label="图片分组" name="group_id">
        <a-select v-model:value="upLoad.group_id" ref="select" style='width:200px' placeholder='请选择分组'>
          <a-select-option value='0'>
            <span>默认未分组</span>
          </a-select-option>
          <a-select-option v-for="v in CateList" :value='v.id' :key="v.id">
            <span>{{v.group_name}}</span>
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item ref="image" label="图片" name="image" help='支持jpg/png格式' :rules="[{ required: true, message: '请上传图片' }]">
        <a-upload v-model:fileList="upLoad.image" v-model:value="upLoad.file" name="file" accept='image/jpeg,image/png,image/jpg,image/gif' list-type="picture-card" multiple @preview="handlePreview" :beforeUpload='()=>false'>
          <div>
            <plus-outlined />
            <div class="ant-upload-text">上传图片</div>
          </div>
        </a-upload>
      </a-form-item>
    </a-form>
  </a-modal>
  <!-- 上传视频 -->
  <a-modal :keyboard="false" title="视频上传" centered v-model:visible="uploadVideoVisible" :confirm-loading="confirmLoading" @ok="handleUpLoad" :width='700'>
    <a-form :label-col="labelCol" :wrapper-col="wrapperCol" ref="upLoadForm" :model="upLoad">
      <a-form-item ref="name" label="视频名称" name="name" :rules="[{ required: true, message: '请输入视频名称' },{ max: 10, message: '视频名称不超过10个字符' }]">
        <a-input v-model:value="upLoad.name" />
      </a-form-item>
      <a-form-item ref="group_id" label="视频分组" name="group_id" :rules="[{ required: true, message: '请选择分组' }]">
        <a-select v-model:value="upLoad.group_id" ref="select" style='width:200px' placeholder='请选择分组'>
          <a-select-option value='0' v-if="CateList.length==0">
            <span>默认未分组</span>
          </a-select-option>
          <a-select-option v-for="v in CateList" :value='v.id' :key="v.id">
            <span>{{v.group_name}}</span>
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item ref="video_image_name" label="视频封面" name="video_image_name" help='支持上传一张' :rules="[{ required: true, message: '请上传视频封面' }]">
        <a-upload name="video_image_name" @change="videoImgChange" v-model:fileList="upLoad.video_image_name" accept='image/jpeg,image/png,image/jpg,image/gif' list-type="picture-card" @preview="handlePreview" :beforeUpload='()=>false'>
          <div>
            <plus-outlined />
            <div class="ant-upload-text">视频封面</div>
          </div>
        </a-upload>
      </a-form-item>
      <a-form-item ref="video" label="视频" name="video" help='支持MP4格式,大小限制2M内，同时只支持上传一部视频。' :rules="[{ required: true, message: '请上传视频' }]">
        <a-upload name="video" v-model:fileList="upLoad.video" @change="videoChange" @previewFile="previewVideo" accept='video/mp4' list-type="picture-card" :beforeUpload='()=>false'>
          <div>
            <plus-outlined />
            <div class="ant-upload-text">上传视频</div>
          </div>
        </a-upload>
      </a-form-item>
    </a-form>
  </a-modal>
  <!-- 图片预览 -->
  <a-modal :keyboard="false" :visible="previewVisible" centered :footer="null" @cancel="previewVisible=false">
    <img alt="example" style="width: 100%" :src="previewImage" />
  </a-modal>
  <!-- 视频预览 -->
  <a-modal :keyboard="false" :visible="previewVideoVisible" centered :footer="null" @cancel="previewVisible=false">
    <video alt="example" style="width: 100%" :src="previewVideo" />
  </a-modal>
  <!-- 修改图片名称 -->
  <a-modal :keyboard="false" title="修改名称" centered v-model:visible="materialVisible" :confirm-loading="confirmLoading" @ok="handleUpdateName" style="width:700px">
    <a-form :label-col="labelCol" :wrapper-col="wrapperCol" ref='materialForm' :model='material'>
      <a-form-item ref="name" label="素材名称" name="name" :rules="[{ required: true, message: '请输入素材名称' },{ max: 10, message: '素材名称不超过10个字符' }]">
        <a-input v-model:value="material.name" />
      </a-form-item>
      <a-form-item ref="id" label="素材ID" name="id" hidden>
        <a-input v-model:value="material.id" />
      </a-form-item>
    </a-form>
  </a-modal>
  <!-- 移动分组-->
  <a-modal :keyboard="false" title="选择分组" centered v-model:visible="materialGroupVisible" :confirm-loading="confirmLoading" @ok="handleMaterialGroup" style="width:700px">
    <a-form :label-col="labelCol" :wrapper-col="wrapperCol" ref='materialGroupForm' :model='materialGroup'>
      <a-form-item ref="group_id" label="素材分组" name="group_id" :rules="[{ required: true, message: '请选择分组' }]">
        <a-select v-model:value="materialGroup.group_id" ref="select" style='width:200px' placeholder='请选择分组'>
          <a-select-option v-for="v in CateList" :value='v.id' :key="v.id">
            <span>{{v.group_name}}</span>
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item ref="id" label="素材ID" name="id" hidden>
        <a-input v-model:value="materialGroup.id" />
      </a-form-item>
    </a-form>
  </a-modal>
</template>
<script>
import { message, Modal } from "ant-design-vue";
import * as Icon from "@ant-design/icons-vue";
import {
  inject,
  onMounted,
  reactive,
  ref,
  toRef,
  toRefs,
  watch,
  onBeforeUnmount,
} from "vue";
import {
  getResourceGroup,
  createResourceGroup,
  uploadImage,
  getImage,
  deleteResourceGroup,
  updateResourceGroup,
  getVideo,
  uploadVideo,
  deleteAll,
  deleteMaterial,
  updateName,
  updateGroup,
} from "@/api/material";
import { iscode } from "@/utils/app";
import store from "@/store";
export default {
  name: "material",
  components: { ...Icon },
  props: {
    groupType: {
      type: Number,
      default() {
        return 1;
      },
    },
    defaultImg: String,
    max: {
      type: Number,
      default() {
        return 1;
      },
    },
    image: String,
    imageList: {
      type: Array,
      default() {
        return [];
      },
    },
    value: Number || Array,
    size: {
      type: Object,
      default() {
        return { width: 104, height: 104 };
      },
    },
  },
  setup(props, context) {
    const state = reactive({
      groupAddType: "add",
      info: store.state.user.info,
      choose: false,
      action: "", //上传地址
      headers: {}, //请求头
      checkedList: [], //checkbox 集合
      indeterminate: true,
      checkAll: false,
      plainOptions: [],
      CateList: [], //分组列表
      visible: false, //分组弹框
      images: [], //图片素材
      defaultSelected: ["-1"], //默认选中分组
      fileList: [], //图片列表
      uploadVisible: false, //上传图片弹窗
      uploadVideoVisible: false, //上传视频弹窗
      loading: false, //加载状态
      confirmLoading: false, //表单提交状态
      previewImage: "",
      previewVideo: "",
      previewVideoVisible: false,
      previewVisible: false,
      total: 0,
      labelCol: { span: 5 },
      wrapperCol: { span: 17 },
    });
    var group_type = ref(props.groupType);
    // 获取分组信息
    const getGroup = async () => {
      let result = await getResourceGroup({ group_type: props.groupType });
      state.CateList = result.data.data;
    };
    // 新建分组
    const groupForm = ref(); //表单
    const group = ref({ group_name: "", group_type: props.groupType });
    const handleOk = () => {
      state.confirmLoading = true;
      groupForm.value
        .validate()
        .then(async (e) => {
          let result;
          if (state.groupAddType == "add") {
            result = await createResourceGroup({
              ...e,
              group_type: props.groupType,
            })
              .then((res) => res.data)
              .catch((error) => error);
          } else {
            result = await updateResourceGroup({
              ...e,
              group_type: props.groupType,
            })
              .then((res) => res.data)
              .catch((error) => error);
          }
          if (iscode(result, true)) {
            groupForm.value.resetFields();
            state.visible = false;
            getGroup();
          }
        })
        .catch((error) => console.log(error));
      state.confirmLoading = false;
    };
    // 删除分组
    const DelCate = (id) => {
      Modal.confirm({
        centered: true,
        content: "删除后该分类将无法恢复，您确定要删除该分类吗？",
        onOk: async () => {
          let res = await deleteResourceGroup(id).then((res) => res.data);
          if (iscode(res, true)) {
            getGroup();
            search.value.group_id = "";
            search.value.page = 1;
            initData(search.value);
          }
        },
      });
    };
    // 上传视频封面变动
    const videoImgChange = (info) => {
      upLoad.value.video_image_name = info.fileList.splice(
        info.fileList.length - 1,
        1
      );
    };
    const videoChange = (info) => {
      upLoad.value.video = info.fileList.splice(info.fileList.length - 1, 1);
    };
    // 上传
    const upLoadForm = ref();
    const upLoad = ref({ image: [], name: "", group_id: "" });
    const handleUpLoad = () => {
      upLoadForm.value
        .validate()
        .then(async (e) => {
          state.confirmLoading = true;
          let formData = new FormData();
          for (let k in e) {
            if (k == "video_image_name") {
              formData.append(
                "video_image_name",
                e["video_image_name"][0].originFileObj
              );
            } else if (k === "image") {
              for (let i = 0; i < e["image"].length; i++) {
                formData.append("image[]", e["image"][i].originFileObj);
              }
            } else {
              if (k == "video") {
                formData.append("video", e[k][0].originFileObj);
              } else {
                formData.append(k, e[k]);
              }
            }
          }
          var result;
          if (e.video) {
            result = await uploadVideo(formData)
              .then((res) => res.data)
              .catch((error) => error);
          } else {
            result = await uploadImage(formData)
              .then((res) => res.data)
              .catch((error) => error);
          }
          state.confirmLoading = false;
          if (iscode(result, true)) {
            upLoadForm.value.resetFields();
            state.uploadVisible = false;
            state.uploadVideoVisible = false;
            search.value.page = 1;
            state.defaultSelected = [upLoad.value.group_id];
            search.value.group_id = upLoad.value.group_id || "";
            initData(search.value);
            upLoad.value = {};
            getGroup();
          }
        })
        .catch((error) => console.log(error));
    };
    // 图片预览
    const handlePreview = async (file) => {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj);
      }
      state.previewImage = file.url || file.preview;
      state.previewVisible = true;
    };
    const getBase64 = (file) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    };
    // 视频预览
    const previewVideo = async (file) => {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj);
      }
      state.previewVideo = file.url || file.preview;
      state.previewVideoVisible = true;
    };
    // 搜索
    var search = ref({ limit: 8, group_id: "", name: "", page: 1 });
    const onSearch = () => {
      search.value.page = 1;
      initData(search.value);
    };
    // 全选
    const onCheckAllChange = (e) => {
      Object.assign(state, {
        checkedList: e.target.checked ? state.plainOptions : [],
      });
    };
    const onChange = (checkedList) => {
      state.indeterminate =
        !!checkedList.length && checkedList.length < state.plainOptions.length;
      state.checkAll = checkedList.length === state.plainOptions.length;
    };
    // 获取列表
    const _lodash = inject("_lodash");
    const initData = async (data) => {
      state.loading = true;
      var result = null;
      if (props.groupType == 1) {
        result = await getImage(data)
          .then((res) => res.data.data)
          .catch((error) => error);
      } else {
        result = await getVideo(data)
          .then((res) => res.data.data)
          .catch((error) => error);
      }
      state.loading = false;
      state.checkedList = [];
      state.images = result.list.data;
      // 整理数据用于全选
      state.plainOptions = _lodash.map(state.images, "id");
      state.total = result.list.total;
    };
    // 点击分组
    const handleMaterialCate = (item, key) => {
      state.images = [];
      search.value.group_id = item.key;
      search.value.page = 1;
      initData(search.value);
    };
    // 分页当前页切换
    const pageCurrentChange = (page, pageSize) => {
      search.value.page = page;
      initData(search.value);
    };
    // 分页当前页显示多少条切换
    const pageSizeChange = (current, limit) => {
      search.value.page = 1;
      search.value.limit = limit;
      initData(search.value);
    };
    onMounted(() => {
      getGroup();
      initData(search.value);
    });
    // 删除素材
    const delMaterial = (id) => {
      Modal.confirm({
        centered: true,
        content: "删除后将无法恢复，您确定要删除吗？",
        onOk: async () => {
          let res = await deleteMaterial({ id }).then((res) => res.data);
          if (iscode(res, true)) {
            search.value.page = 1;
            initData(search.value);
            getGroup();
          }
        },
      });
    };
    // 批量删除
    const productMaterialDel = async () => {
      Modal.confirm({
        centered: true,
        content: "删除后将无法恢复，您确定要删除吗？",
        onOk: async () => {
          let res = await deleteAll({
            id: JSON.stringify(state.checkedList),
          }).then((res) => res.data);
          if (iscode(res, true)) {
            search.value.page = 1;
            initData(search.value);
          }
        },
      });
    };
    // 复制
    const copy = (link) => {
      var input = document.createElement("input"); // 直接构建input
      input.value = link; // 设置内容
      document.body.appendChild(input); // 添加临时实例
      input.select(); // 选择实例内容
      document.execCommand("Copy"); // 执行复制
      document.body.removeChild(input); // 删除临时实例
      message.success("复制成功");
    };
    // 修改素材名称
    const material = ref(); //存放修改数据
    const materialForm = ref(); //声明表单
    const materialVisible = ref(false);
    const changName = (data) => {
      materialVisible.value = true;
      material.value = data;
    };
    // 提交修改
    const handleUpdateName = () => {
      materialForm.value.validate().then(async (e) => {
        let result = await updateName(e)
          .then((res) => res.data)
          .catch((error) => error);
        if (iscode(result, true)) {
          materialVisible.value = false;
          initData(search.value);
          getGroup();
        }
      });
    };
    // 修改分组
    const materialGroupForm = ref(); //声明表单
    const materialGroup = ref({ id: "", group_id: "" }); //存放修改数据
    const materialGroupVisible = ref(false);
    const changGroup = (data) => {
      materialGroupVisible.value = true;
      materialGroup.value.id = data.join(",");
    };
    const handleMaterialGroup = () => {
      materialGroupForm.value.validate().then(async (e) => {
        let result = await updateGroup(e)
          .then((res) => res.data)
          .catch((error) => error);
        if (iscode(result, true)) {
          materialGroupVisible.value = false;
          initData(search.value);
          getGroup();
        }
      });
    };
    // 确认选择
    const handleChoose = () => {
      if (!state.checkedList.length) {
        message.error("请选择"+props.groupType == 1?'图片':'视频');
        return;
      }
      if (state.checkedList.length + props.imageList.length > props.max) {
        message.error(
          `最大可选择${props.max}${
            props.groupType == 1 ? "张图片" : "部视频"
          },已选数量:${state.checkedList.length + props.imageList.length}`
        );
        return;
      }
      var imageUrl = [];
      // var video_image_name
      state.images.forEach((v) => {
        if (state.checkedList.includes(v.id)) {
          var url = v.file_name;
          if (props.max > 1) {
            if (props.groupType == 2) {
              imageUrl.push(v);
            } else {
              imageUrl.push(url);
            }
          } else {
            if (props.groupType == 2) {
              imageUrl = v;
            } else {
              imageUrl = url;
            }
          }
        }
      });
      state.choose = false;
      state.checkedList = [];
      state.checkAll = false;

      context.emit("handlechoose", imageUrl);
    };
    // 点击对应的图片
    const clickImg = (k) => {
      context.emit("handleclick", k);
    };
    // 删除所选的突破
    const delChooseImg = (k) => {
      if (props.imageList) {
        var imageList = props.imageList;
        imageList.splice(k, 1);
        context.emit("handledel", imageList);
      } else {
        console.log(1)
        context.emit("handledel", "");
      }
    };
    onBeforeUnmount(() => {
      // instance.destroy();
      // instance = null;
    });
    return {
      ...toRefs(state),
      group_type,
      onSearch,
      search,
      group,
      handleOk,
      handleMaterialCate,
      groupForm,
      upLoadForm,
      handleUpLoad,
      upLoad,
      videoImgChange,
      handlePreview,
      pageSizeChange,
      pageCurrentChange,
      DelCate,
      delMaterial,
      onChange,
      onCheckAllChange,
      productMaterialDel,
      copy,
      changName,
      handleUpdateName,
      materialForm,
      material,
      materialVisible,
      handleMaterialGroup,
      changGroup,
      materialGroup,
      materialGroupForm,
      materialGroupVisible,
      handleChoose,
      clickImg,
      delChooseImg,
      videoChange,
      previewVideo,
    };
  },
};
</script>
<style lang="less">
.fileBox {
  .ant-upload-disabled {
    cursor: pointer !important;
  }
}
</style>
<style lang="less" scoped>
.librayList {
  border: 1px solid #eee;
  flex-wrap: wrap;
  max-height: 699px;
  overflow: hidden;
  min-width: 100%;

  li {
    border-right: 1px solid #eee;
    padding-bottom: 17px;
    border-bottom: 1px solid #eee;

    &:nth-child(4n) {
      border-right: none;
    }

    &:nth-child(n + 5) {
      border-bottom: 0;
    }

    .content {
      box-sizing: border-box;
      padding: 17px;
      padding-bottom: 0;

      .imgContent {
        width: 150px;
        height: 150px;
        overflow: hidden;
      }

      img {
        width: 100%;
        display: block;
        margin: 0 auto;
      }
    }

    .material_foot {
      padding: 0 20px;
      cursor: pointer;

      .button-group {
        width: 100%;
        padding: 8px 0;
        background-color: #f5f5f8;
        font-size: 14px;
        font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        font-weight: 400;
        color: #05486a;
        display: flex;

        div {
          flex: 1;
          text-align: center;
        }
      }
    }
  }
}
.ant-form-item-control-wrapper {
  width: 60% !important;
  display: inline-block;
}
.content{
  position: relative;
  &:hover .preview{
   display: block;
  }
  .preview{
    width:150px;
    height: 150px;
    position: absolute;
    background-color: #000;
    display: none;
    top: 17px;
    left: 17px;
      video{
        width: 150px;
        height: 150px;
      }
  }
}

</style>